import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import Cookies from 'js-cookie';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      
      setAuth: (user, token) => {
        Cookies.set('orderstatus_token', token, { expires: 1 });
        set({ user, token, isAuthenticated: true });
      },
      
      logout: () => {
        Cookies.remove('orderstatus_token');
        set({ user: null, token: null, isAuthenticated: false });
      },
      
      getToken: () => {
        return get().token || Cookies.get('orderstatus_token');
      },
      
      updateUser: (userData) => {
        set({ user: { ...get().user, ...userData } });
      }
    }),
    {
      name: 'orderstatus-auth',
      partialize: (state) => ({ user: state.user, token: state.token, isAuthenticated: state.isAuthenticated }),
    }
  )
);

export default useAuthStore;
